// extracted by mini-css-extract-plugin
export var blob_left_1 = "styles-module--blob_left_1--f0fde";
export var blob_left_2 = "styles-module--blob_left_2--86545";
export var blob_right_1 = "styles-module--blob_right_1--9309f";
export var blur_blob = "styles-module--blur_blob--28d20";
export var content_wrapper = "styles-module--content_wrapper--18cf8";
export var date = "styles-module--date--d336e";
export var subheading = "styles-module--subheading--d356c";
export var wrapper = "styles-module--wrapper--06771";